module.exports = require('./assignInWith');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/extendWith.js
// module id = 1856
// module chunks = 1